// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 132 ? "SvgContainer" : chunkId) + "." + {"132":"af82ca03","213":"e5a70eaa","348":"2b23b23e","599":"75f668a0","667":"8907eb10"}[chunkId] + ".chunk.js";
};